// extracted by mini-css-extract-plugin
module.exports = {"root":"CompleteLink_root__2PHWD","rootSuccess":"CompleteLink_rootSuccess__DUryr","rootFailure":"CompleteLink_rootFailure__2aulC","isDisabled":"CompleteLink_isDisabled__2uTLJ"};